"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchWithHeaders = exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash.merge"));
var _jwtDecode = _interopRequireDefault(require("jwt-decode"));
var _auth = _interopRequireDefault(require("../services/auth"));
var _appConfigHelper = require("./appConfigHelper");
var _environmentHelper = _interopRequireDefault(require("./environmentHelper"));
var _eventDispatcher = _interopRequireWildcard(require("./eventDispatcher"));
var _package = require("../../package.json");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const JWT = 'CLEENG_AUTH_TOKEN';
const REFRESH_TOKEN = 'CLEENG_REFRESH_TOKEN';
const ENVIRONMENT = 'CLEENG_ENVIRONMENT';
const retrieveJWT = () => (0, _appConfigHelper.getData)(JWT);
const retrieveRefreshToken = () => (0, _appConfigHelper.getData)(REFRESH_TOKEN);
const retrieveEnvironment = () => (0, _appConfigHelper.getData)(ENVIRONMENT);
let IS_FETCHING_REFRESH_TOKEN = false;
let REFRESH_TOKEN_ERROR = false;
const isJWTExpired = () => {
  const jwt = retrieveJWT();
  if (jwt) {
    const decoded = (0, _jwtDecode.default)(jwt);
    return Date.now() / 1000 > decoded.exp;
  }
  return true;
};
const fetchNewTokens = async () => {
  const API_URL = (0, _environmentHelper.default)();
  const environment = retrieveEnvironment();
  IS_FETCHING_REFRESH_TOKEN = true;
  const response = await fetch("".concat(API_URL, "/auths/refresh_token"), {
    method: 'POST',
    body: JSON.stringify({
      refreshToken: (0, _appConfigHelper.getData)('CLEENG_REFRESH_TOKEN')
    }),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...(environment === 'production' && {
        'X-Requested-By': "mediastore-sdk@".concat(_package.version)
      })
    }
  });
  const responseJSON = await response.json();
  (0, _appConfigHelper.setData)(JWT, responseJSON.responseData.jwt);
  (0, _appConfigHelper.setData)(REFRESH_TOKEN, responseJSON.responseData.refreshToken);
};
const generatePromiseWithHeaders = (url, options) => {
  const token = retrieveJWT();
  const environment = retrieveEnvironment();
  let optionsWithToken = options;
  if (token != null) {
    optionsWithToken = (0, _lodash.default)({}, options, {
      headers: {
        Authorization: "Bearer ".concat(token),
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...(environment === 'production' && {
          'X-Requested-By': "mediastore-sdk@".concat(_package.version)
        })
      }
    });
  }
  return window.fetch(url, optionsWithToken);
};
const fetchWithJWT = async function (url) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const isExpired = isJWTExpired();
  const refreshToken = retrieveRefreshToken();
  if (isExpired && !refreshToken) {
    (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_AUTH_FAILED);
    _auth.default.logout();
  }
  if (isExpired && refreshToken) {
    if (!IS_FETCHING_REFRESH_TOKEN) {
      await fetchNewTokens().then(() => {
        IS_FETCHING_REFRESH_TOKEN = false;
      }).catch(() => {
        IS_FETCHING_REFRESH_TOKEN = false;
        REFRESH_TOKEN_ERROR = true;
        (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_AUTH_FAILED);
        _auth.default.logout();
        return new Promise((resolve, reject) => reject());
      });
    } else {
      return new Promise((resolve, reject) => {
        const isRefreshTokenFetched = () => {
          if (REFRESH_TOKEN_ERROR) {
            reject();
            return;
          }
          if (!IS_FETCHING_REFRESH_TOKEN) {
            resolve(generatePromiseWithHeaders(url, options));
            return;
          }
          setTimeout(() => {
            isRefreshTokenFetched();
          }, 500);
        };
        isRefreshTokenFetched();
      });
    }
  }
  return generatePromiseWithHeaders(url, options);
};
const fetchWithHeaders = async function (url) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const environment = retrieveEnvironment();
  const optionsWithToken = (0, _lodash.default)({}, options, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...(environment === 'production' && {
        'X-Requested-By': "mediastore-sdk@".concat(_package.version)
      })
    }
  });
  return window.fetch(url, optionsWithToken);
};
exports.fetchWithHeaders = fetchWithHeaders;
var _default = exports.default = fetchWithJWT;